"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.providerSpecialtiesArray = void 0;
exports.providerSpecialtiesArray = [
    "aptofisico",
    "auditoria",
    "cardiologia",
    "cirugia",
    "clinicamedica",
    "clinicocuidadosdomiciliarios",
    "dermatologia",
    "diabetologia",
    "diabetologia",
    "ejecutivodesaludcuidadosdomiciliarios",
    "endocrinologia",
    "farmacovigilancia",
    "flebologia",
    "gastroenterologia",
    "ginecologia",
    "hematologia",
    "internista",
    "medicinafamiliar",
    "medicinageneral",
    "medicinalaboral",
    "neumonologia",
    "neurologia",
    "nutricionista",
    "oftalmologia",
    "oncologia",
    "otorrinolaringologia",
    "paliativocuidadosdomiciliarios",
    "pediatracuidadosdomiciliarios",
    "pediatria",
    "psicologia",
    "psiquiatria",
    "reumatologia",
    "traumatologia",
    "urologia",
];
